import type { EFileStatus, RecordStatus, Upload } from '@tabservice/tabfile-client';
import { Pill } from '@/components/ui/pill';
import { filingStatusMeta, recordStatusMeta, uploadStatusMeta } from './status';

export function FilingStatusPill({ status }: { status: EFileStatus }) {
  const meta = filingStatusMeta[status];
  return (
    <Pill tone={meta.tone} title={meta.hint}>
      {meta.label}
    </Pill>
  );
}

export function RecordStatusPill({ status }: { status: RecordStatus }) {
  const meta = recordStatusMeta[status];
  return (
    <Pill tone={meta.tone} title={meta.hint}>
      {meta.label}
    </Pill>
  );
}

export function UploadStatusPill({ status }: { status: NonNullable<Upload['status']> }) {
  const meta = uploadStatusMeta[status];
  return (
    <Pill tone={meta.tone} title={meta.hint}>
      {meta.label}
    </Pill>
  );
}
